/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EntryTokenGroup } from './EntryTokenGroup';
import {
    EntryTokenGroupFromJSON,
    EntryTokenGroupFromJSONTyped,
    EntryTokenGroupToJSON,
    EntryTokenGroupToJSONTyped,
} from './EntryTokenGroup';

/**
 * 
 * @export
 * @interface GetMyEntryTokensResponse
 */
export interface GetMyEntryTokensResponse {
    /**
     * 
     * @type {Array<EntryTokenGroup>}
     * @memberof GetMyEntryTokensResponse
     */
    tokens: Array<EntryTokenGroup>;
    /**
     * Total un-consumed entry tokens held, across every type.
     * @type {number}
     * @memberof GetMyEntryTokensResponse
     */
    totalCount: number;
}

/**
 * Check if a given object implements the GetMyEntryTokensResponse interface.
 */
export function instanceOfGetMyEntryTokensResponse(value: object): value is GetMyEntryTokensResponse {
    if (!('tokens' in value) || value['tokens'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    return true;
}

export function GetMyEntryTokensResponseFromJSON(json: any): GetMyEntryTokensResponse {
    return GetMyEntryTokensResponseFromJSONTyped(json, false);
}

export function GetMyEntryTokensResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMyEntryTokensResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tokens': ((json['tokens'] as Array<any>).map(EntryTokenGroupFromJSON)),
        'totalCount': json['totalCount'],
    };
}

export function GetMyEntryTokensResponseToJSON(json: any): GetMyEntryTokensResponse {
    return GetMyEntryTokensResponseToJSONTyped(json, false);
}

export function GetMyEntryTokensResponseToJSONTyped(value?: GetMyEntryTokensResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tokens': ((value['tokens'] as Array<any>).map(EntryTokenGroupToJSON)),
        'totalCount': value['totalCount'],
    };
}

